import axios from 'axios';

import auth from "@/store/authentication.js";
const user_role = auth.state.user_role;

export default {
  findAll({ type="partners", main_id = '', ...ctx }) {
    return axios.get(`${api_url}${user_role}/${type}/${main_id}/stores`);
  },
  fields({ type="partners" }) {
    return axios.get(`${api_url}${user_role}/${type}/store-fields`);
  },
  find(id) {
    return axios.get(api_url + user_role + "/partners/" + id.id);
  },
  create({ type="partners", main_id = '', data = {} }) {
    return axios.post(`${api_url}${user_role}/${type}/${main_id}/stores`, data);
  },
  update({ type="partners", main_id = '', id, data = {} }) {
    return axios.post(`${api_url}${user_role}/${type}/stores/${id}`, data);
  },
  delete(id) {
    return axios.delete(api_url + user_role + "/partners/" + id.id);
  }
}



// WEBPACK FOOTER //
// ./src/api/store.js